"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showToast = exports.default = exports.ToastStyle = exports.Toast = exports.TOAST_TYPE = exports.TOAST_POSITION = void 0;
Object.defineProperty(exports, "toast", {
  enumerable: true,
  get: function get() {
    return _reactToastify.toast;
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactToastify = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _infoFilledCerulean = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/info-filled-cerulean.svg"));
var _successFilled = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/success-filled.svg"));
var _warningFilled = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/warning-filled.svg"));
var _errorFilled = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/error-filled.svg"));
var _Text = require("../../Text/Text");
var _reactIntl = require("react-intl");
var _excluded = ["children", "classes", "className", "opener", "theme", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type Node } from 'react';*/ /* Docs: https://github.com/fkhadra/react-toastify/ */ /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var LIB = 'Toastify__toast';
var ToastStyle = exports.ToastStyle = function ToastStyle(theme /*: ThemeType*/) {
  return {
    root: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      zIndex: theme.zIndex.toast,
      minWidth: '25rem'
    }, "& .".concat(LIB), {
      padding: '1rem 1.875rem 1rem 3.16rem',
      color: theme.colors.pebbleGrey,
      borderRadius: theme.variables.borderRadiusSmall,
      borderLeftWidth: '.525rem',
      borderStyle: 'solid',
      backgroundColor: theme.colors.white,
      backgroundPosition: '.75rem 1.25rem',
      backgroundRepeat: 'no-repeat',
      borderColor: theme.colors.cerulean,
      backgroundImage: "url(".concat(_infoFilledCerulean.default, ")"),
      backgroundSize: '1.75rem'
    }), "& .".concat(LIB, "--error"), {
      borderColor: theme.colors.dullRed,
      backgroundImage: "url(".concat(_errorFilled.default, ")")
    }), "& .".concat(LIB, "--success"), {
      borderColor: theme.colors.olive,
      backgroundImage: "url(".concat(_successFilled.default, ")")
    }), "& .".concat(LIB, "--warning"), {
      borderColor: theme.colors.canary,
      backgroundImage: "url(".concat(_warningFilled.default, ")")
    })
  };
};
var TOAST_TYPE = exports.TOAST_TYPE = {
  error: 'error',
  info: 'info',
  success: 'success',
  warn: 'warn'
};
var TOAST_POSITION = exports.TOAST_POSITION = {
  bottomCenter: 'bottom-center',
  bottomLeft: 'bottom-left',
  bottomRight: 'bottom-right',
  topCenter: 'top-center',
  topLeft: 'top-left',
  topRight: 'top-right'
};
var defaultOptions = {
  closeButton: false,
  position: TOAST_POSITION.topRight,
  newestOnTop: true,
  draggablePercent: 15
};
/*:: type Props = InjectSheetProvidedProps & {
  children: Node,
  opener?: Node,
  type: 'error' | 'info' | 'success' | 'warn'
};*/
/*:: type ToastMessageProps = {
  title: Node,
  message: Node
};*/
var ToastMessage = function ToastMessage(_ref /*:: */) {
  var title = _ref /*:: */.title,
    message = _ref /*:: */.message;
  return /*#__PURE__*/ /*: Node*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Text.Header4, null, title), /*#__PURE__*/_react.default.createElement(_Text.SmallText, null, message));
};
ToastMessage.displayName = 'ToastMessage';
var notification = function notification(type /*: string*/, message /*: Node*/, title /*: Node*/) {
  var options /*: Object*/ = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var mergedOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  switch (type) {
    case TOAST_TYPE.error:
      return _reactToastify.toast.error(/*#__PURE__*/_react.default.createElement(ToastMessage, {
        title: title || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "toast.title.error",
          defaultMessage: "Error"
        }),
        message: message
      }), mergedOptions);
    case TOAST_TYPE.info:
      return _reactToastify.toast.info(/*#__PURE__*/_react.default.createElement(ToastMessage, {
        title: title || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "toast.title.info",
          defaultMessage: "Info"
        }),
        message: message
      }), mergedOptions);
    case TOAST_TYPE.success:
      return _reactToastify.toast.success(/*#__PURE__*/_react.default.createElement(ToastMessage, {
        title: title || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "toast.title.success",
          defaultMessage: "Success"
        }),
        message: message
      }), mergedOptions);
    case TOAST_TYPE.warn:
      return _reactToastify.toast.warn(/*#__PURE__*/_react.default.createElement(ToastMessage, {
        title: title || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "toast.title.warning",
          defaultMessage: "Warning"
        }),
        message: message
      }), mergedOptions);
  }
};
var Toast = exports.Toast = function Toast(_ref2 /*:: */) /*: Node*/{
  var children = _ref2 /*:: */.children,
    classes = _ref2 /*:: */.classes,
    className = _ref2 /*:: */.className,
    opener = _ref2 /*:: */.opener,
    theme = _ref2 /*:: */.theme,
    type = _ref2 /*:: */.type,
    props = (0, _objectWithoutProperties2.default)(_ref2 /*:: */, _excluded);
  var hasChildren = !!children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, opener && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    "data-testid": "opener",
    onClick: function onClick() {
      notification(type, children);
    }
  }, opener), /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props))), !opener && hasChildren && notification(type, children) && /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props)), !opener && !hasChildren && /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props)));
};
Toast.displayName = 'Toast';
Toast.defaultProps = {
  type: TOAST_TYPE.info
};
var _default = exports.default = (0, _injectSheet.default)(ToastStyle)(Toast);
var showToast = exports.showToast = notification;
//# sourceMappingURL=Toast.js.map